import Box from '@mui/material/Box'

import type { Styles } from '../types/Styles'

export { DspLogo }

const logo = '/images/dsp-logo-liggend.svg'

type Props = {
  sx?: Styles
}

const defaultStyles: Styles = {
  maxHeight: 34,
}

const DspLogo = ({ sx }: Props) => {
  return (
    <Box
      sx={{ ...defaultStyles, ...sx }}
      component="img"
      src={logo}
      alt="DSP logo"
    />
  )
}
